import { render } from "./SettingsOnboardComponent.vue?vue&type=template&id=7e40bdb6&scoped=true"
import script from "./SettingsOnboardComponent.vue?vue&type=script&lang=js"
export * from "./SettingsOnboardComponent.vue?vue&type=script&lang=js"

import "./SettingsOnboardComponent.vue?vue&type=style&index=0&id=7e40bdb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e40bdb6"]])

export default __exports__